import type { BillingTerm } from "~/components/billing-toggle";

/** Central links for the customer dashboard and provisioning flows. */
export const purchasePortal = {
  baseUrl: "https://dash.hostright.de",
  paths: {
    webHosting: "/",
  },
  planUrls: {
    starter: "https://dash.hostright.de/products/shared-da-starter",
    growth: "https://dash.hostright.de/products/shared-da-growth-plan",
    business: "https://dash.hostright.de/products/shared-da-business-plan",
  },
} as const;

type PurchaseProduct = keyof typeof purchasePortal.paths;

export function getPurchaseUrl({
  product,
  plan,
  billingTerm,
  engine,
}: {
  product: PurchaseProduct;
  plan?: string;
  billingTerm?: BillingTerm;
  engine?: string;
}) {
  const planUrl = plan
    ? purchasePortal.planUrls[
        plan.toLowerCase() as keyof typeof purchasePortal.planUrls
      ]
    : undefined;

  if (product === "webHosting" && planUrl) return planUrl;

  const url = new URL(purchasePortal.paths[product], purchasePortal.baseUrl);
  if (plan) url.searchParams.set("plan", plan.toLowerCase());
  if (billingTerm) url.searchParams.set("term", billingTerm);
  if (engine) url.searchParams.set("engine", engine);
  return url.toString();
}
